(function ($) {
    $.fn.basicUpload = function(options) {
        var el = $(this)
        var id = el[0].id;
        if (!id) {
            return;
        }

        var settings = $.extend({
            buttons: {
                upload: el.data('upload') != undefined ? el.data('upload') : false,
                change: el.data('change') != undefined ? el.data('change') : true,
                delete: el.data('delete') != undefined ? el.data('delete') : false,
                delete: el.data('rotate') != undefined ? el.data('rotate') : false,
            },
            urls: {
                upload: el.data('uploadUrl') != undefined ? el.data('uploadUrl') : false,
                delete: el.data('deleteUrl') != undefined ? el.data('deleteUrl') : false,
            },
            image: el.data('image') != undefined ? el.data('image') : false,
        }, options);

        var html = createMarkUp(settings, id);

        el.before(html);
        el.css('display', 'none').addClass('basicUpload').data('target', '#preview-' + id);

        $('#' + id + '.basicUpload').on('change', function() {
            showImagePreview(this, $(this).data('target'), '#image-upload-container-' + id);
        });

        if (settings.buttons.upload) {
            $('[data-toggle="upload-file"]').on('click', function() {
                uploadFile(id, settings.urls.upload, settings.image);
            });
        }

        $('label.rotate').on('click', function (){
            var el = $(this);

            var degree = el.data('degree') != undefined ? el.data('degree') + 90 : 90;
            if (degree >= 360) {
                degree = 0;
            }

            $('#preview-' + id).css({
                '-webkit-transform': 'rotate(' + degree + 'deg)',
                '-moz-transform':    'rotate(' + degree + 'deg)',
                '-ms-transform':     'rotate(' + degree + 'deg)',
                'transform':         'rotate(' + degree + 'deg)'
            });
            el.data('degree', degree);
        });
    };

    $('[data-toggle="basicUpload"]').each(function(index, el) {
        $(el).basicUpload();
    });

    function createMarkUp(settings, id) {
        var overlay  = '<div class="mini-overlay">';
            overlay += '<div class="mini-snackbar">';
            overlay += '<div class="content"></div>';
            overlay += '</div>';
            overlay += '<div class="mini-loader"></div>';
            overlay += '</div>';
        var buttons = '<div class="buttons">';

        if (settings.buttons.upload) {
            buttons += '<label class="upload" data-toggle="upload-file" data-input="#' + id + '">';
            buttons += ' <i class="fas fa-upload fa-2x"></i>';
            buttons += '</label>';
        }
        if (settings.buttons.change) {
            buttons += ' <label for="' + id + '" class="change">';
            buttons += '<i class="fas fa-edit fa-2x"></i>';
            buttons += '</label>';
        }
        if (settings.buttons.delete) {
            buttons += ' <label class="delete">';
            buttons += '<i class="fas fa-minus-circle fa-2x"></i>';
            buttons += '</label>';
        }
        if (settings.buttons.delete) {
            buttons += ' <label class="rotate" data-id="' + id + '">';
            buttons += '<i class="fas fa-sync-alt fa-2x"></i>';
            buttons += '</label>';
        }
        buttons += '</div>';

        var markup  = '<div class="image-upload-container" id="image-upload-container-' + id +'"><div class="image-preview" id="preview-' + id + '"' + (settings.image ? 'style="background-image: url(' + settings.image + ')"' : '') +'></div>';
            markup += overlay + buttons;
            markup += '</div>';

        return markup;
    }

    function showImagePreview(input, target, container) {
        if (input.files && input.files[0]) {
            if (input.files[0].type == 'image/png' || input.files[0].type == 'image/jpeg') {
                var reader = new FileReader();
                reader.onload = function (e) {
                    $(target).css('background-image', 'url(' + e.target.result + ')');
                    $(container + ' .buttons label.upload').show();
                }
                reader.readAsDataURL(input.files[0]);
            } else {
                showMiniResponse(container, 'Tipo di file non supportato');
            }
        }
    }

    function uploadFile(inputID, sUrl, oldImage) {
        var input = $('#' + inputID)[0];
        var text = '';

        if (input.files && input.files[0]) {
            $('#image-upload-container-' + inputID + ' .mini-overlay .mini-loader').show();
            $('#image-upload-container-' + inputID + ' .mini-overlay').show();

            var formData = new FormData();
            formData.append('new', input.files[0]);
            if (oldImage) {
                formData.append('old', oldImage);
            }

            $.ajax({
                url: sUrl,
                type: 'POST',
                data: formData,
                cache:false,
                contentType: false,
                processData: false,
            })
            .done(function(result) {
                text = 'Immagine aggiornata';
                $('#image-upload-container-' + inputID + ' .buttons label.upload').hide();
            })
            .fail(function() {
                text = 'Impossibile aggiornare l\'immagine';
                //$(data.target).css('background-image', 'url(' + data.old + ')');
            })
            .always(function() {
                $(input).val('');
                $('#image-upload-container-' + inputID + ' .mini-overlay .mini-loader').fadeOut('fast', function() {
                    showMiniResponse('#image-upload-container-' + inputID, text);
                });
            });
        } else {
            text = 'Non è stata selezionata nessuna immagine';
            showMiniResponse('#image-upload-container-' + inputID, text);
        }
    }

    function showMiniResponse (target, text) {
        $(target + ' .mini-snackbar .content').text(text);
        $(target + ' .mini-overlay').fadeIn('fast', function() {
            $(target + ' .mini-snackbar').fadeIn(2000, function(){
                $(this).fadeOut(1000, function() {
                    $(target + ' .mini-overlay').fadeOut();
                });
            });
        });
    }
}(jQuery));



// WEBPACK FOOTER //
// ./resources/assets/js/components/basicUpload.js